export enum Web3dTool {
  // Existing Tools
  PathNavigation = 'pathNavigation',
  AngleMeasurement = 'angleMeasurement',
  CameraShortcuts = 'cameraShortcuts',
  Fly = 'fly',
  LineMeasurement = 'measurement',
  PolylineMeasurement = 'polylineMeasurement',
  PolygonMeasurement = 'polygonMeasurement',
  Orbit = 'orbit',
  Pan = 'pan',
  PanoramaControls = 'panoramaControls',
  Picking = 'picking',
  PlanarControls = 'planarControls',
  PointMeasurement = 'pointMarkup',
  Selection = 'selection',
  Zoom = 'zoom',
  PolygonTool = 'polygonTool',
  TransformTool = 'transformTool',
  CompoundCurve = 'compoundCurve',
  RectangleTool = 'rectangleTool',
  ThreePointRectangleTool = 'threePointRectangleTool',
  CircleTool = 'circleTool',
  PointTool = 'pointTool',
  TrimExtend = 'trimExtend',
  FilletTool = 'filletTool',
  JoinTool = 'joinTool',
  InsertNodeTool = 'insertNodeTool',
  BreakLine = 'breakLine',
}

export const DEFAULT_WEB3D_TOOL = Web3dTool.Selection;
